import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { TabContent } from "reactstrap";
import auth from "../../services/authservice";
import xtos from "../../utils/xtos.js";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
// import { getUsers } from "../../services/users";
import { getUsers } from "../../services/users.js";
import http from "../../services/httpService.js";
import { getCOOItems, saveCOOItem, batchUpdateCOOItems } from "./../../services/cooitems";
// import BasicInfo from "./BasicInfoFields/BasicInfo.jsx";
import ReusableTab from "./../../newcommon/ReusableTab";
import ReusableTabNavs from "./../../newcommon/ReusableTabNavs";
import { deleteAttachments, saveAttachments } from "../../services/attachments";
// import SpreadSheet from "./SpreadSheet";
// import Spreadsheet from "./Spreadsheet/SpreadSheet.jsx";
import Spreadsheet from "./Spreadsheet/SpreadsheetEditor.jsx";
import Tabsharing from "../../common/Tabsharing.jsx";
// import Notes from "../../common/actions.js";

const apiUrl = process.env.REACT_APP_API_URL;

const COOitemXLS = (props) => {
  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();
  const { id: COOitemId } = useParams();
  const [nonRegisteredUser, setNonRegisteredUser] = useState(false);
  const [registeredUser, setRegisteredUser] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [readOnly, setReadOnly] = useState(true);

  const [read, setRead] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [users, setUsers] = useState([]);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const userProfile = auth.getProfile();

  const [sheetState, setSheetState] = useState({});
  const [rowIdMap, setRowIdMap] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  console.log("SheetState", sheetState);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get("tab") || 1; // Move this line up
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    const queryTab = parseInt(queryParams.get("tab"), 10);
    if (queryTab && queryTab !== activeTab) {
      setActiveTab(queryTab);
    }
  }, [location.search]);

  const formatApiToSheet = (apiData) => {
    const headers = Object.keys(apiData[0]).filter((key) => key !== "id");
    const sheet = {
      name: "sheet1",
      freeze: "A1",
      rows: {},
      styles: [{ font: { bold: true } }],
    };

    const rowIdMap = {};

    // Header row
    sheet.rows["0"] = {
      cells: headers.reduce((acc, key, colIndex) => {
        acc[String(colIndex)] = { text: key, style: 0 };
        return acc;
      }, {}),
    };

    // Data rows
    apiData.forEach((item, index) => {
      const rowIndex = index + 1;
      rowIdMap[rowIndex] = item.id;

      sheet.rows[rowIndex] = {
        cells: headers.reduce((acc, key, colIndex) => {
          let value = item[key];
          if (Array.isArray(value)) value = value.join(", ");
          else if (typeof value === "object" && value !== null) value = JSON.stringify(value);
          else value = String(value ?? "");

          acc[String(colIndex)] = { text: value };
          return acc;
        }, {}),
      };
    });

    setRowIdMap(rowIdMap);
    return sheet;
  };


  const populateCOOItem = async () => {
    try {

      const { data: COOitem } = await getCOOItems();

      const getSheetData = COOitem.map((item) => ({
        id: item._id,
        username: item?.user?.username,
        SKU: item.SKU,
        repairVendor: item.repairVendor,
        serial: item.serial,
        batch: item.batch,
        madeIn: item.madeIn,
        COOfromDB: item.COOfromDB,
        COOonBox: item.COOonBox,
        COOfromPackingList: item.COOfromPackingList,
        note: item.note,
        status: item.status,
      }));

      const formatCooItems = formatApiToSheet(getSheetData);
      setSheetState(formatCooItems);

    } catch (ex) {
      console.error(ex);
    }
  };


  const populateUsers = async () => {
    const { data: usersData } = await getUsers();
    setUsers(usersData);
  };

  useEffect(() => {
    const fetchData = async () => {
      await populateCOOItem();
      await populateUsers();
      setIsLoading(false);
    };

    fetchData();
  }, []);

  function formatSheetToApi(sheetData, rowIdMap) {
    const rows = sheetData?.rows || {};
    const headers = rows["0"]?.cells || {};

    const headerKeys = Object.keys(headers)
      .map((key) => headers[key]?.text?.trim())
      .filter(Boolean);

    const apiFormatted = [];

    Object.entries(rows).forEach(([rowIndex, row]) => {
      if (rowIndex === "0") return;

      const cells = row.cells || {};
      const item = {};

      headerKeys.forEach((header, colIndex) => {
        const colKey = String(colIndex);
        let value = cells[colKey]?.text ?? "";

        try {
          value = JSON.parse(value);
        } catch {
          // keep as string
        }

        item[header] = value;
      });

      // Attach the original id if it existed
      if (rowIdMap[rowIndex]) {
        item.id = rowIdMap[rowIndex];
      }

      if (item?.id) {
        apiFormatted.push(item);
      }
    });

    return apiFormatted;
  }

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const updatedData = formatSheetToApi(sheetState, rowIdMap);

      await batchUpdateCOOItems(updatedData);
      toast.success("Data saved successfully!");
      setIsSaving(false);
    } catch (err) {
      console.error("Save failed", err);
      setIsSaving(false);
      // alert("Something went wrong.");
    }
  };

  return (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/COOitems">COOItems</Link>
        </li>
      </ol>
      <h1 className="page-header">COOItems XLS-view</h1>
      <div className="row">
        <div className="col-12">
          <Panel>
            <PanelHeader noButton></PanelHeader>
            <PanelBody>
              <h1>{data.SKU}</h1>

              {isSaving ? (
                <button
                  className="btn btn-primary mb-3"
                >
                  <Spinner animation="border" size="sm" /> Saving...
                </button>
               ) : (
                <button
                  onClick={handleSave}
                  className="btn btn-primary mb-3"
                >
                  Save Changes
                </button>
              )
              }


              {sheetState?.rows ? (
                <Spreadsheet data={sheetState} setData={setSheetState} />
              ) : (
                <div>Loading spreadsheet...</div>
              )}

            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default COOitemXLS;
